import React from 'react'

const PermissionRequired = () => {
  return (
    <div className="text-center">
      <p className="text-base font-semibold text-indigo-600">403</p>
      <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Permission Denied</h1>
      <p className="mt-6 text-base leading-7 text-gray-600">Please contact site adminstration for permission</p>
    </div>
  )
}

export default PermissionRequired